import { apiClient } from '../config/apiConfig';

const PHONEPE_API_BASE = process.env.REACT_APP_PHONEPE_API_BASE || '/api/phonepe/website';

export interface PhonePePrefillDetails {
  name?: string;
  email?: string;
  contact?: string;
}

export interface InitiatePhonePePaymentRequest {
  amountRupees: number;
  currency: string;
  redirectUrl: string;
  merchantOrderId?: string;
  prefillUserLoginDetails?: {
    phoneNumber?: string;
  };
  customerDetails?: PhonePePrefillDetails;
}

export interface InitiatePhonePePaymentResponse {
  success?: boolean;
  message?: string;
  orderId?: string;
  merchantOrderId?: string;
  state?: string;
  expireAt?: number;
  redirectUrl?: string;
}

export interface VerifyPhonePePaymentRequest {
  merchantOrderId?: string;
  orderId?: string;
  transactionId?: string;
  paymentId?: string;
  status?: string;
  phonePeParams?: Record<string, string>;
}

export interface VerifyPhonePePaymentResponse {
  success: boolean;
  message?: string;
  status?: string;
}

export async function initiatePhonePePayment(
  payload: InitiatePhonePePaymentRequest
): Promise<InitiatePhonePePaymentResponse> {
  const response = await apiClient.post(`${PHONEPE_API_BASE}/initiate-payment`, payload);
  return response.data;
}

export async function verifyPhonePePayment(
  payload: VerifyPhonePePaymentRequest
): Promise<VerifyPhonePePaymentResponse> {
  const response = await apiClient.post(`${PHONEPE_API_BASE}/verify-payment`, payload);
  return response.data;
}